<template>
  <div class="head-bg">
    <div class="head-tank">
      <div class="lang-list">
        <span
          :class="lang === 'zh_hk' ? 'active' : ''"
          @click="changeLang('zh_hk')"
          >繁體中文</span
        >
        <span :class="lang === 'en' ? 'active' : ''" @click="changeLang('en')"
          >English</span
        >
      </div>
      <a
        target="_blank"
        href="http://inspiringhk.org/#/inspiringHk/subscribe"
        class="subscribe"
        >{{ $t("head.subscribe") }}</a
      >
      <a
        target="_blank"
        href="https://donation.inspiringhk.org/"
        class="donate"
        >{{ $t("head.donate") }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: "en",
    };
  },
  created() {
    if (window.localStorage.getItem("locale")) {
      this.lang = window.localStorage.getItem("locale");
    }
    // 如果地址栏带有local参数并且是第一次进入页面则进入
    if (
      this.$router.currentRoute.query.local &&
      window.localStorage.getItem("firstCome") === null
    ) {
      window.localStorage.setItem("firstCome", 1);
      this.$i18n.locale = this.lang =
        this.$router.currentRoute.query.local === "en" ? "en" : "zh_hk";
      this.$router.push({ path: "/home" });
    }
  },
  methods: {
    // 切换语言
    changeLang(lang) {
      this.lang = lang;
      this.$i18n.locale = lang;
      window.localStorage.setItem("locale", lang);
      this.$router.go(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.head-bg {
  width: 100%;
  background: #fff;
  height: 45px;
  border-bottom: 1px solid #e7e5e6;
  z-index: 1;
  position: relative;
  .head-tank {
    max-width: 1200px;
    margin: 0 auto;
    .donate,
    .subscribe,
    .lang-list {
      float: right;
      height: 45px;
      line-height: 45px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      margin: 0 4px;
    }
    .donate,
    .subscribe {
      width: 105px;
      cursor: pointer;
    }
    .donate {
      background: #de3e3e;
    }
    .subscribe {
      background: #6495ed;
    }
    .lang-list {
      padding: 7px 0;
      line-height: 30px;
      box-sizing: border-box;
      span {
        color: #444;
        display: inline-block;
        height: 30px;
        padding: 0 5px;
        cursor: pointer;
      }
      .active {
        background: #a7d16b;
        color: #fff;
      }
    }
  }
}
</style>
